module.exports = __webpack_public_path__ + "static/media/instagram.d8a222e4.svg";